<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Novo Signatário</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- Pergunta -->
            <div v-if="seen">
              <div class="centered">
                <h5>O signatário ja está cadastrado na plataforma?</h5>
              </div>

              <div class="row mt-3">
                <button
                  class="btn btn-danger col-4 offset-1"
                  @click="(newUser = true), (seen = false)"
                >
                  Não
                </button>
                <button
                  class="btn btn-success col-4 offset-2"
                  @click="(newUser = false), (seen = false)"
                >
                  Sim
                </button>
              </div>
            </div>
            <!-- Buscar Signatário ja cadastrado -->
            <div v-if="newUser === false">
              <h5>Digite e selecione o nome do signatário:</h5>
                    <v-select
                      :options="users"
                      label="name"
                      :filterable="true"
                      v-model="userInSelect"
                    >
                    <template slot="no-options">
                    <div v-show="!loading">Nenhum usuário foi encontrado com este nome</div>
                    <div class="row" style="position:relative; left: 160px" v-show="loading">
                    <div class="loader"></div>
                    <div>&nbsp; Carregando usuários...</div>
                    </div>
                    </template>
                    </v-select>
              <br />
              <button
                data-dismiss="modal"
                type="button"
                class="btn btn-add float-right"
                @click="saveUserInSelect()"
              >
                <i class="fa fa-save"></i> Salvar
              </button>
                  <button
                    @click="(seen = newUser = null), (seen = true)"
                    type="button"
                    class="btn btn-return"
                  >
                    <i class="fa fa-arrow-left"></i> Voltar
                  </button>
            </div>
            <!-- Novo Signatário -->
            <div v-if="newUser">
              <h5>Por favor, registre o signatário:</h5>
              <label>Nome:</label>
              <div class="col-xs-4">
                <input class="form-control" v-model="userToRegister.name" />
              </div>
              <label>Email:</label>
              <div class="col-xs-4">
                <input class="form-control" v-model="userToRegister.email" />
              </div>
              <label>CPF:</label>
              <div class="col-xs-4">
                <input class="form-control" v-model="userToRegister.cpf" v-mask="'###.###.###-##'"/>
              </div>
              <label>Data de nascimento:</label>
              <div class="col-xs-4">
                <input
                  class="form-control"
                  type="date"
                  v-model="userToRegister.birth_date"
                />
              </div>
              <div class="row mt-3">
                <div class="col-3">
                  <button
                    @click="(seen = newUser = null), (seen = true)"
                    type="button"
                    class="btn btn-primary"
                  >
                    Voltar
                  </button>
                </div>
                <div class="col-9 text-right">
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="inputPerson"
                  >
                    Registrar e Incluir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 centered">
        <i
          @click="goTo(1)"
          :class="[
            'step-btn',
            { active: step == 1 },
            { 'cant-step-here': lastStepEverReached < 1 },
          ]"
          >1</i
        >
      </div>
      <div class="col-md-4 centered">
        <i
          @click="goTo(2)"
          :class="[
            'step-btn',
            { active: step == 2 },
            { 'cant-step-here': lastStepEverReached < 2 },
          ]"
          >2</i
        >
      </div>
      <div class="col-md-4 centered">
        <i
          @click="goTo(3)"
          :class="[
            'step-btn',
            { active: step == 3 },
            { 'cant-step-here': lastStepEverReached < 3 },
          ]"
          >3</i
        >
      </div>
    </div>
    <hr />
    <div class="step-body" v-show="step == 1">
      <div class="centered">
        <h3 class="mt-3">Por favor insira o documento:</h3>
      </div>
      <input id="fileInputed" type="file" hidden @change="fileInputed()" />
      <div class="mt-3 row card-columns">
        <div class="card card-sm offset-5 col-2" v-if="file">
          <div class="centered">
            <i class="centered pt-2 fa fa-2x fa-file-pdf red"></i>
          </div>
          <div class="card-body">
            <h5 class="card-title">
              {{ file.name }}
            </h5>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item no-border-bottom" style="margin-bottom: -0px;">
              <b>Tamanho:</b> {{ file.file.size / 1000 }} kB
            </li>
          </ul>
          <button
            id="trash-btn"
            class="btn btn-sm btn-danger"
            @click="removeFile()"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div
          class="card card-sm add-one offset-5 col-2 centered clickable"
          @click="addClicked()"
          v-if="!file"
        >
          <h5 class="card-title mt-3">Adicionar documento</h5>
          <i class="centered p-4 fa fa-2x fa-plus green"></i>
        </div>
      </div>
      <div class="row">
        <div class="offset-4 col-md-4">
          <label>Nome do documento</label>
          <input type="text" class="form-control" v-model="detatched.name" />
        </div>
      </div>
    </div>

    <!-- Signatários -->
    <div class="step-body" v-show="step == 2">
      <div class="row">
        <div class="col-12 centered">
          <button
            type="button"
            class="btn btn-success"
            data-toggle="modal"
            data-target="#exampleModal"
            @click="(newUser = ''), (seen = true)"
          >
            <i class="fa fa-plus"></i> Adicionar Signatário
          </button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-8 offset-2 centered">
          <table class="table table-striped table-hover">
            <thead> 
              <tr > 
                <th></th>
                <th scope="col">Ordem</th>
                <th scope="col">Nome</th>
                <th scope="col">E-mail</th>
                <th scope="col">Nascimento</th>
                <th scope="col">Remover</th>
              </tr>
            </thead>
            <draggable v-model="people" tag="tbody">
              <tr v-for="(person, personIndex) in people" :key="personIndex">
                <td><i class="fas fa-arrows-alt"></i></td>
                <td style="pointer-events:none" scope="row">{{ personIndex + 1 }}</td>
                <td style="pointer-events:none" >{{ person.name }}</td>
                <td style="pointer-events:none" >{{ person.email }}</td>
                <td style="pointer-events:none" >{{ person.birth_date | moment }}</td>
                <td style="pointer-events:none" >
                  <button
                    style="pointer-events:auto"
                    class="btn btn-danger"
                    @click="removePerson(personIndex)"
                  >
                    <i class="fas fa-user-times"></i>
                  </button>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </div>
    <div class="step-body" v-show="step == 3">
      <div class="col-6 offset-3">
        <h5>Mensagem para os assinantes</h5>
        <textarea rows="4" class="form-control" v-model="description"></textarea>
      </div>
      <br />
      <div class="col-6 offset-3">
        <h5>Data Limite das Assinaturas</h5>
      </div>
      <div class="col-6 offset-3">
        <VueCtkDateTimePicker
          color="#03a830"
          :only-date="true"
          :no-header="true"
          :no-button-now="true"
          :auto-close="true"
          label="Selecione a data"
          :min-date="nowDate"
          formatted="LL"
          v-model="signatureDeadline"
        ></VueCtkDateTimePicker>
      </div>
    </div>
    <div class="row mt-4 mb-4">
      <div class="col-md-12 form-page__actions" style="justify-content: center; float: none;">
        <button class="btn btn-return" @click="previous">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>
        <button class="btn btn-add" @click="next">
          {{ nextLabel }}
          <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VSelectDefault from "../Utils/VSelectDefault";
import draggable from "vuedraggable";
import vSelect from "vue-select";

export default {
  data() {
    return {
      userToRegister: {
        name: "",
        cpf: "",
        email: "",
        birth_date: "",
      },
      userInSelect: null,
      users: [],
      lastStepEverReached: 1,
      step: 1,
      detatched: {
        name: "",
      },
      file: null,
      people: [],
      newUser: "",
      seen: true,
      description: "",
      signatureDeadline: "",
      inputName: "",
      inputEmail: "",
      inputBirthDate: "",
      nowDate: moment().format("YYYY-MM-DD"),
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    saveUserInSelect() {
      if(this.userInSelect != null){
        this.people.push(this.userInSelect);
        this.userInSelect = null;
      } else {
        this.$message("Erro", "Nenhum signatário foi selecionado", "error");
      }
    },
    goTo(which) {
      if (this.lastStepEverReached >= which || which < this.step)
        this.step = which;
    },
    previous(){
      if(this.step === 1){
        return this.$router.push("/multipleSignature");
      } else {
        return this.step--;
      }
    },
    next() {
      if (this.step === 1 && this.file != null && this.detatched.name != "") {
        this.step++;
        if (this.lastStepEverReached < this.step)
            this.lastStepEverReached = this.step;
                return
      } else if (this.step === 1 && this.file == null || this.detatched.name == "") {
          this.$message("Erro", "Por favor, adicione o documento e nome", "error");
          return
      }

      if (this.step === 2 && this.people != "") {
        this.step++;
        if (this.lastStepEverReached < this.step)
            this.lastStepEverReached = this.step;
                return
      } else if (this.step === 2 && this.people == "") {
          this.$message("Erro", "Por favor, adicione signatários", "error");
          return
      }

      if (this.step === 3 && this.signatureDeadline != "" && this.description != ""){
        return this.save();
      } else if (this.step === 3 && this.signatureDeadline == "" || this.description == "") {
          this.$message("Erro", "Por favor, preencha o campo da descrição e da data limite", "error");3
          return
      }
    },
    removePerson(personIndex) {
      this.people.splice(personIndex, 1);
    },
    inputPerson() {
      $("#page_loader").show();
      const self = this;
      const api = self.$store.state.api + "users";

      self.$http
        .post(api, {
          name: self.userToRegister.name,
          cpf: self.userToRegister.cpf,
          email: self.userToRegister.email,
          birth_date: self.userToRegister.birth_date,
        })
        .then((response) => {
          self.userToRegister = {
            name: "",
            cpf: "",
            email: "",
            birth_date: "",
          };
          self.people.push(response.data);
          $("#exampleModal").modal("hide");
          $("#page_loader").hide();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    removeFile() {
      this.file = null;
    },
    
    addClicked() {
      $("#fileInputed").click();
    },
    save() {
      $("#page_loader").show();

      const self = this;
      let api = self.$store.state.api + "signature-multiple-user-index";

      const id = this.$route.params.id;
      if (id) {
        api += "/" + id;
      }

      const fd = self.makeFormData();

      if (!fd) {
        $("#page_loader").hide();
        return;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Documento cadastrado com sucesso",
            "success"
          );
          self.$router.push("/multipleSignature");
          $("#page_loader").hide();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          $("#page_loader").hide();
        });
    },
    makeFormData() {
      const self = this;
      const fd = new FormData();

      fd.append("arquivo[nome]", self.file.name);
      fd.append("arquivo[conteudo]", document.getElementById("fileInputed").files[0]);
      fd.append("arquivo[idProcesso]", 9999);
      fd.append("arquivo[tipo]", self.detatched.name);
      fd.append("arquivo[data]", moment().format("YYYY-MM-DD"));
      fd.append("arquivo[hora]", moment().format("HH:mm"));

      self.people.forEach((user, index) => {
        fd.append("users[" + index + "][id]", user.id);
        fd.append("users[" + index + "][nomeFunc]", user.name);
        fd.append("users[" + index + "][email]", user.email);
        fd.append("users[" + index + "][cpfFunc]", user.cpf);
        fd.append("users[" + index + "][birthDate]", user.birth_Date);
        fd.append("users[" + index + "][idProcesso]", 9999);
        fd.append("users[" + index + "][data]", moment().format("YYYY-MM-DD"));
      });

      fd.append("description", self.description);
      fd.append("limit_date", moment(self.signatureDeadline).set({'hour': 23, 'minute': 59, 'second': 59}).format("YYYY-MM-DD HH:mm:ss"));
      fd.append("name", self.detatched.name);

      fd.append("is_detatched_sending", 1);

      fd.append("controle[idEnvio]", 99999);
      fd.append("controle[tipoProcesso]", self.detatched.name);
      fd.append("controle[dataEnvio]", moment().format("YYYY-MM-DD"));
      fd.append("controle[horaEnvio]", moment().format("HH:mm"));

      const id = self.$route.params.id;
      if (id) {
        fd.append("id", id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getBase64(file) {
      const self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.file.base64 = reader.result.split(",")[1];
      };
    },
    fileInputed() {
      const file = document.getElementById("fileInputed").files[0];
      if (file) {
        const name = this.getFileName(
          document.getElementById("fileInputed").value
        );
        const nameSplitted = name.split(".");

        if (nameSplitted[nameSplitted.length - 1] !== "pdf") {
          this.$message("Erro", "O arquivo precisa ser do tipo PDF", "error");
          return;
        }

        //Colocando o nome automaticamente no campo [nome] da tela
        this.detatched.name = nameSplitted.slice(0, -1).join(".");

        this.file = {
          name: name,
          file: file,
          base64: this.getBase64(file),
          sign: false,
        };
      }
    },
    getFileName(fullPath) {
      var startIndex =
        fullPath.indexOf("\\") >= 0
          ? fullPath.lastIndexOf("\\")
          : fullPath.lastIndexOf("/");
      var filename = fullPath.substring(startIndex);
      if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
        filename = filename.substring(1);
      }
      return filename;
    },
    getUsers() {
      this.loading = true;
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        this.loading = false;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        this.loading = false;
        });
    },
  },

  mounted() {
    this.getUsers();
  },
  computed: {
    nextLabel() {
      if (this.step === 3) return "Enviar para Assinatura";

      return "Próximo";
    },
  },
  components: {
    VSelectDefault,
    draggable,
    vSelect,
  },
};
</script>

<style scoped>
#trash-btn {
  position: absolute;
  top: 2px;
  right: 2px;
}
.card-sm {
  width: 200px !important;
  min-height: 125px;
}
.add-one {
  border: 3px dashed gray;
  background: #e6e6e6;
  border-radius: 0.5rem;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.step-body {
  min-height: 350px;
}
.table thead th {
  background-color: #03a830;
  color: rgb(255, 255, 255);
  cursor: default;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.table-striped tr {
    cursor: pointer;
}
.table thead th:hover {
  cursor: default;
}
.loader {
  border: 4px solid #cecece;
  border-top: 4px solid #000000; 
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>



// WEBPACK FOOTER //
// src/components/MultipleSignature/MultipleSignature.vue